/**
 * @param AddressForm Base widget for extending
 * @returns Billing Address Correction Form widget
 */
function BillingAddressCorrectionFormClassCreator(AddressForm: import('widgets/forms/AddressForm').TAddressForm) {
    /**
     * @category widgets
     * @subcategory checkout
     * @class BillingAddressCorrectionForm
     * @augments AddressForm
     * @classdesc Billing address correction form. Is used inside modal to ask customer change not valid address coming from 3PI payment.
     */
    class BillingAddressCorrectionForm extends AddressForm {
        init() {
            /**
             * @description Show modal
             * @emits 'closemodal'
             */
            this.emit('showmodal');
            this.validate();
        }

        /**
         * @description Update order on submission and close modal
         * @param data - Server response object
         */
        onSubmitted(data: TServerResponse) {
            if (data.success && data.order) {
                this.eventBus().emit('billing.address.corrected', data.order);
                /**
                 * @description Close modal
                 * @emits 'closemodal'
                 */
                this.emit('closemodal');
            }
        }
    }

    return BillingAddressCorrectionForm;
}

export type TBillingAddressCorrectionForm = ReturnType<typeof BillingAddressCorrectionFormClassCreator>;

export type TBillingAddressCorrectionFormInstance = InstanceType<TBillingAddressCorrectionForm>;

export default BillingAddressCorrectionFormClassCreator;
